export default __webpack_public_path__ + "static/media/payprop-logo.6a090201.svg";